<template>
<div>
    <h1 class="subtitle">Proyectos</h1>
    <div class="nj-cols">
        <div class="nj-card">
            <div class="nj-cols form c3">
                <div>
                    <div class="nj-label">Código</div>
                    <input type="text" class="nj-text" v-model="filters.pry_codigo" ref="pry_codigo">
                </div>
                <div>
                    <div class="nj-label">Nombre</div>
                    <input type="text" class="nj-text" v-model="filters.pry_nombre">
                </div>
                <div>
                    <div class="nj-label">Estado</div>
                    <select name="" id="" class="nj-select" v-model="filters.pry_estado">
                        <option value="">Todos</option>
                        <option value="1">Activo</option>
                        <option value="0">Inactivo</option>
                    </select>
                </div>
            </div>
            <Buttons line>
                <button class="nj-button" @click="buscar()">Buscar</button>
                <button class="nj-button c-green" @click="openRegistrar()">Nuevo</button>
            </Buttons>
        </div>
        <div class="nj-card">
            <b-table :data="proyectos" :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage" :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition"
                :default-sort-direction="defaultSortDirection" :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon" :sort-icon-size="sortIconSize" default-sort="pry_nombre"
                aria-next-label="Next page" aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
                <template slot-scope="props">
                    <b-table-column label="Código" header-class="is-info">{{ props.row.pry_codigo }}</b-table-column>
                    <b-table-column label="Proyecto" header-class="is-info">{{ props.row.pry_nombre }}</b-table-column>
                    <b-table-column label="Estado" header-class="is-info">
                        <b-field>
                            <b-tag :class="tagEstado(props.row.pry_estado)">{{ props.row.pry_estado_nombre }}</b-tag>
                        </b-field>
                    </b-table-column>
                    <b-table-column label="Opciones" header-class="is-info">
                        <div class="nj-flx">
                            <button class="nj-button icon" @click="openAsignarEmpleados(props.row.pry_id)" title="Asignar Empleados"><i class="mdi mdi-account-plus"></i></button>
                            <button class="nj-button icon" @click="openModificar(props.row.pry_id)" title="Modificar"><i class="mdi mdi-pencil"></i></button>
                        </div>
                    </b-table-column>
                </template>
            </b-table>
        </div>
    </div>
    <ProyectoNew v-if="showRegistrar" @close="closeRegistrar($event)" />
    <ProyectoEdit v-if="showModificar" @close="closeModificar($event)" :pry_id="pry_id" />
    <ProyectoAsignarEmpleados v-if="showAsignarEmpleados" @close="closeAsignarEmpleados($event)" :pry_id="pry_id" />
</div>
</template>

<script>
import { ProyectoService } from "../../services"
import Toast from "../../util/toast"
import ProyectoNew from "./ProyectoNew"
import ProyectoEdit from "./ProyectoEdit"
import ProyectoAsignarEmpleados from "./ProyectoAssignarEmpleados"
import Estado from "../../constants/estado"
import { Buttons } from "../components"

export default {
    name: "ProyectoList",
    components: {
        ProyectoNew,
        ProyectoEdit,
        ProyectoAsignarEmpleados,
        Buttons,

        

    },
    data() {
        return {
            filters: {
                pry_codigo: null,
                pry_nombre: null,
                pry_estado: 1,
            },
            proyectos: [],
            pry_id: null,
            showRegistrar: false,
            showModificar: false,
            showAsignarEmpleados: false,
            isPaginated: true,
            isPaginationSimple: false,
            isPaginationRounded: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 10,
        }
    },
    methods: {
        buscar() {
            ProyectoService.buscar(this.filters).then(
                response => {
                    this.proyectos = response.data
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        tagEstado(id) {
            return Estado.Tag(id)
        },
        openRegistrar() {
            this.showRegistrar = true
        },
        closeRegistrar(condition) {
            this.showRegistrar = false
            if (condition) {
                this.buscar()
            }
        },
        openModificar(id) {
            this.pry_id = id
            this.showModificar = true
        },
        closeModificar(condition) {
            this.pry_id = null
            this.showModificar = false
            if (condition) {
                this.buscar()
            }
        },
        openAsignarEmpleados(id) {
            this.pry_id = id
            this.showAsignarEmpleados = true
        },
        closeAsignarEmpleados() {
            this.pry_id = null
            this.showAsignarEmpleados = false
        },

    },
    mounted() {
        this.$refs.pry_codigo.focus()
        this.buscar()

        window.addEventListener("keyup", (event) => {
            if (event.code == "Escape") {
                this.closeRegistrar()
                this.closeModificar()
                this.closeAsignarEmpleados()
            }
        })
    }
}
</script>

<style scoped></style>